require("./bootstrap");
require("slick-carousel");
require("./menu.js");

// efectos de entrada
import AOS from "aos";
import "aos/dist/aos.css";

import "./modernizr-custom";

$("#loading").fadeOut();

$(document).ready(function () {
    /*! Desarrollado por Inmore Creative https://www.inmore.cl/ !*/

    $(window).scroll(function () {
        let scrollTop = $(this).scrollTop();

        if (scrollTop > 5) {
            $("header").addClass("scroll");
            $("body").addClass("scroll");
        } else {
            $("header").removeClass("scroll");
            $("body").removeClass("scroll");
        }
    });


    AOS.init();
});
